module.exports = __webpack_public_path__ + "static/media/MoMo_Logo.6e406ef3.png";